const s = (r, t) => r.interceptors.request.use((e) => (e.baseURL = t(), e.url = `${e.baseURL}` + e.url, e));
export {
  s as default
};
//# sourceMappingURL=url-interceptor.js.map
